import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* getNpcEntries(action: any): any {
  try {
    yield put({ type: npcLogConstant.GET_NPC_ENTRIES_LOADER });
    const response = yield call(npcLogService.getNpcEntries, action.payload);
    if (response?.status === 200) {
      yield put({ type: npcLogConstant.GET_NPC_ENTRIES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: npcLogConstant.GET_NPC_ENTRIES_FAILURE, payload: error });
  }
}

function* getNpcEntriesSaga() {
  yield takeEvery(npcLogConstant.GET_NPC_ENTRIES_REQUEST, getNpcEntries);
}

export default getNpcEntriesSaga;
